import { FC } from 'react'
import { CustomBaseAlert } from './CustomBaseAlert'

export const CustomErrorAlert: FC<{ children?: React.ReactNode }> = ({
	children,
}) => {
	return <CustomBaseAlert type="danger">{children}</CustomBaseAlert>
}
